import React, { FC, ReactNode } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import useGetAllRelationships, {
  UseGetAllRelationshipsReturnType,
} from '../hooks/useGetAllRelationships';
import { Relationship } from '../types/types';

interface RelationshipsProviderProps {
  children: ReactNode;
  sourceEntityDomain: string;
  sourceEntityType: string;
  sourceEntityIds?: string[];
  disableRelationshipService?: boolean;
  relationshipEntitiesList?: Relationship[];
}

const RelationshipsContext =
  getOrCreateGlobalContext<UseGetAllRelationshipsReturnType>(
    CONTEXT_NAMES.RelationshipsContext,
  );

export const useRelationshipsContext = () =>
  useContextWithValidation<UseGetAllRelationshipsReturnType>(
    RelationshipsContext,
    {
      hook: 'useRelationshipsContext',
      provider: 'RelationshipsProvider',
    },
  );

const RelationshipsProvider: FC<RelationshipsProviderProps> = ({
  children,
  sourceEntityIds,
  sourceEntityDomain,
  sourceEntityType,
  disableRelationshipService,
  relationshipEntitiesList,
}) => {
  const contextValue = useGetAllRelationships(
    sourceEntityDomain,
    sourceEntityType,
    sourceEntityIds,
    disableRelationshipService,
    relationshipEntitiesList,
  );

  return (
    <RelationshipsContext.Provider value={contextValue}>
      {children}
    </RelationshipsContext.Provider>
  );
};

RelationshipsProvider.displayName = 'RelationshipsProvider';

export default RelationshipsProvider;
